import { render, staticRenderFns } from "./Alunos.vue?vue&type=template&id=70521254&"
import script from "./Alunos.vue?vue&type=script&lang=js&"
export * from "./Alunos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports